<script lang="ts">
	//Formatters
	import { format } from 'src/services/i18n';
	//Design system components
	import { Alert } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from 'src/types/Device';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	//Stores
	import { navigateToSetting } from 'src/stores/ui/navigate-to';

	export let device: Device;
	export let values: { minVersion: string; fwVersion: string } = { minVersion: '', fwVersion: '' };
	export let isOffline = false;
</script>

<Alert
	type="warning"
	heading={$format('alert_heading_update_required', {
		default: 'Firmware update required',
	})}
	message={values?.minVersion
		? $format('alert_message_mandatory_firmware_update', {
				values: { minVersion: values.minVersion },
				default: 'Please update your device to version {minVersion} or later.',
			})
		: $format('device_status_unsupported', {
				default: 'Firmware is not supported. Update required',
			})}
	class="mb-s"
	cta={{
		title:
			isOffline || device?.shared
				? ''
				: capFirstChar(
						$format('sub_settings_title_firmware_update', {
							default: 'Firmware upgrade',
						}),
					),
	}}
	on:cta_click={() => navigateToSetting(device.id, 'settings', 'firmware_version')}
/>
